export default {
  brand: {
    name: 'CYMA',
    fullName: '希玛石油制品（镇江）有限公司',
    tagline: '智慧化学 · 定制润滑'
  },
  nav: {
    home: '首页',
    about: '关于希玛',
    products: '产品中心',
    oil: '油性润滑系列',
    water: '水性润滑系列',
    cases: '应用案例',
    contact: '联系我们',
    join: '加入我们'
  },
  hero: {
    badge: 'SIGMA PRECISION LUBRICATION',
    title: '定制特种润滑油',
    titleAccent: '驱动工业未来',
    subtitle: '集研发、生产、销售、服务于一体的高新技术企业。以「基于定制，创造价值」为使命，为全球客户提供智慧化学润滑解决方案。',
    ctaPrimary: '探索产品',
    ctaSecondary: '联系我们',
    stat1: '行业深耕',
    stat1Unit: '年+',
    stat2: '合作企业',
    stat2Unit: '+',
    stat3: '定制品类',
    stat3Unit: '+',
    stat4: '体系认证',
    stat4Unit: '+'
  },
  about: {
    label: 'ABOUT CYMA',
    title: '关于希玛',
    subtitle: '石油制品定制专家 / 行业深耕15+年 / 为客户创造核心价值',
    p1: '希玛石油制品（镇江）有限公司，创立于2010年，坐落于国家级化工产业园。是集生产、研发、销售、服务于一体的高品质定制化工艺润滑油生产企业。希玛承裹「开发、责任、效率、团队、创新」的精神，不断丰富和延展经营战略的内涵。在特种润滑定制领域实现了跨越式快速发展，市场竞争地位显著提高。',
    p2: '「希玛」二字来自希腊文「Sigma」（汉译：希格玛）。领先与智慧的代表，意味着品质零缺陷。希玛石油创领「智慧化学」，凭借前进的科研检测队伍，承裹「定制+研发+服务」的理念，坚持以「基于定制，创造价值」为己任，为客户定制开发特种油品。专心服务每一位客户，专注于技术研发，解决客户各种润滑难题。',
    p3: '公司现有研发中心、检测中心、分析中心。公司与中国石油大学、江苏大学、江苏科技大学等国内知名学院建立产学结合实验室，技术方面具有较强的供给保障能力。并拥有国内一流的调和技术和先进的检测设备、分析设备。希玛主要产品包括：定制化特种润滑油，钢帘线拉丝液、铜拉丝液、切削液、金属加工用油、防锈油、导热油、高温链条油、冷冻机油、空压机油、真空泵油、齿轮油、液压油等特种用油。',
    p4: '希玛石油制品（镇江）有限公司是国家重点支持的高新技术企业，先后通过了ISO9001质量管理体系、ISO14001环境管理体系认证、IATF16949体系认证，确保产品质量的稳定和对环境的保护，满足更深度的市场要求。目前，「希玛」产品已经成为我国定制化特种润滑油行业的新风向。希玛石油制品（镇江）有限公司以提供优质全程服务为宗旨，深化品牌建设，愿与国内外相关行业开展各种形式的技术交流与合作，建立互利互惠、长期稳定的战略伙伴关系，共同促进中国特种润滑油事业的发展。'
  },
  pillars: {
    label: 'CORE CAPABILITIES',
    title: '三大核心能力',
    tech: { title: '技术定制', desc: '根据客户不同设备技术需求，及时研发定制，提出定制化匹配用油解决方案。' },
    product: { title: '产品交付', desc: '对接研发生产优质高效的产品，确保产品生产及配送及时有效的满足客户需求。' },
    service: { title: '全程保障', desc: '提供周到细致的售后服务，针对客户的油品、保存产品质量等相关售后问题及时现场实地取样、送检，快速解决。' }
  },
  products: {
    label: 'PRODUCT LINES',
    title: '产品矩阵',
    oil: '油性产品系列',
    oilDesc: '工业润滑 · 金属加工 · 特种定制',
    water: '水性产品系列',
    waterDesc: '环保配方 · 防锈清洗 · 绿色制造',
    viewAll: '查看全部'
  },
  culture: {
    label: 'CULTURE',
    title: '企业文化',
    items: [
      { title: '企业精神', desc: '领先源于研发和创新' },
      { title: '企业愿望', desc: '让润滑油定制成为希玛核心竞争力' },
      { title: '核心价值观', desc: '价值来源于有益于客户的产品或服务，尊重个人，人尽其才，团队协作精神，遵循商业道德' },
      { title: '经营理念', desc: '决策以客户及市场需求为导向，以客户为目标设计业务流程并不断优化，为员工提供与能力相适应的职位平台' }
    ]
  },
  certs: {
    label: 'CERTIFICATIONS',
    title: '荣誉资质',
    subtitle: '国际体系认证 · 品质与环境双重保障',
    items: ['ISO9001 质量管理体系', 'ISO14001 环境管理体系', 'IATF16949 汽车质量体系', '危险化学品经营许可']
  },
  cta: {
    title: '开启您的定制润滑方案',
    subtitle: '专业团队 7×24 响应 · 免费技术咨询',
    button: '立即咨询'
  },
  footer: {
    rights: '版权所有',
    icp: '苏ICP备19014159号',
    address: '江苏省镇江市大港新区松林山路9号',
    phone: '13913213555',
    email: 'runjia7@163.com'
  },
  contact: {
    title: '联系我们',
    subtitle: '专业团队随时为您提供咨询服务',
    phone: '电话咨询',
    email: '邮件联系',
    address: '公司地址',
    map: '我们的位置',
    viewMap: '点击查看原图'
  },
  float: {
    phone: '联系电话',
    wechat: '微信咨询'
  },
  productsPage: {
    label: 'PRODUCTS',
    title: '产品中心',
    subtitle: '油性、水性两大润滑油系列，以及消泡剂、快T、聚羧酸盐、珠光浆、脱叶增效剂五大助剂系列',
    oilTitle: '油性产品系列',
    oilDesc: '工业润滑 · 金属加工 · 特种定制',
    waterTitle: '水性产品系列',
    waterDesc: '环保配方 · 防锈清洗 · 绿色制造',
    browse: '进入系列 →',
    categories: '产品分类',
    subCategories: '产品品名',
    empty: '暂无相关产品',
    model: '型号',
    intro: '产品介绍',
    features: '显著特点',
    scope: '适用范围',
    specs: '典型数据',
    prev: '上一页',
    next: '下一页',
    pageInfo: '第 {page} 页 / 共 {total} 页',
    contactLabel: '联系电话：'
  },
  aboutPage: {
    label: 'ABOUT CYMA',
    title: '关于希玛'
  },
  cases: {
    label: 'APPLICATIONS',
    title: '应用案例',
    subtitle: '覆盖拉丝、3C、汽车、电池、金属加工等多领域润滑解决方案',
    filterAll: '全部案例',
    filterLsy: '拉丝液',
    filterCcLy: '3C领域',
    filterQcLy: '汽车领域',
    filterDcLy: '电池领域',
    filterJsZp: '金属制品',
    filterRhLY: '润滑领域',
    typeLsy: '拉丝液',
    typeCcLy: '3C',
    typeQcLy: '汽车',
    typeDcLy: '电池',
    typeJsZp: '金属',
    typeRhLY: '润滑'
  },
  joinPage: {
    label: 'JOIN US',
    title: '加入我们',
    subtitle: '与希玛同行，共创智慧化学未来',
    industryLabel: 'INDUSTRY',
    industryTitle: '涉及行业',
    dutyLabel: 'RESPONSIBILITIES',
    dutyTitle: '岗位职责',
    reqLabel: 'REQUIREMENTS',
    reqTitle: '任职要求',
    locationLabel: 'LOCATIONS',
    locationTitle: '工作地点',
    contactTitle: '联系我们',
    hotline: '招聘热线',
    hotlineValue: '王经理 18651818682',
    emailLabel: '简历投递',
    emailValue: 'wangwen@ximapetro.cn',
    jobs: [
      {
        name: '化工大客户销售经理',
        contactName: '王经理',
        contactPhone: '18651818682',
        contactEmail: 'wangwen@ximapetro.cn',
        overview: [
          { label: '需求人数', value: '6人' },
          { label: '汇报上级', value: '产品线销售总监' },
          { label: '下属人数', value: '无' }
        ],
        industry: '',
        duties: [
          '负责根据公司整体战略，结合产品市场特点，制定年度、季度及月度销售计划与目标分解；',
          '负责定期分析产品市场动态、竞争对手动向及客户痛点，识别增长机会，提出新产品研发需求；',
          '负责对销售额、毛利率、回款率等核心KPI负责，确保完成或超额完成公司下达的销售指标；',
          '负责客户信息收集、投标、报价、客户的谈判与合同签订，处理客户投诉，定期输出销售报告，分析销售数据，提出改进措施；',
          '做好本职其他相关工作。'
        ],
        requirements: [
          '大专及以上学历，5年以上企业客户销售经验，熟悉所负责产品线的产品和行业客户情况；',
          '过往有1000万以上的年销售业绩，有可开发转化的客户资源；',
          '熟悉大客户销售全流程工作，能够独立自主开展工作，必要时寻求上级领导的帮助。'
        ],
        locations: [
          { city: '镇江', addr: '江苏省镇江市镇江新区国际化工园区松林山路9号（希玛石油销售（镇江）有限公司）' },
          { city: '昆山', addr: '江苏省昆山市昆太路祥和国际大厦11楼1102号（希玛石油昆山办事处）' },
          { city: '上海', addr: '歆翱智慧谷上海市闵行区颛桥镇都庄路2350号（希玛石油（集团）研发和销售中心）' }
        ]
      },
      {
        name: '硅油产线销售总监',
        contactName: '王经理',
        contactPhone: '18651818682',
        contactEmail: 'wangwen@ximapetro.cn',
        overview: [
          { label: '需求人数', value: '1人' },
          { label: '汇报上级', value: '集团董事长' },
          { label: '下属', value: '大客户销售经理/代表' },
          { label: '团队规模', value: '3-6人' }
        ],
        industry: '',
        duties: [
          '负责根据公司硅油产线整体市场战略，结合硅油产线市场特点（如竞争格局、客户需求、经济环境），制定年度、季度及月度销售计划与目标分解；',
          '负责定期分析产品线市场动态、竞争对手动向及客户痛点，识别增长机会，提出新产品研发需求；',
          '负责对产品线总销售额、毛利率、回款等核心KPI负责，确保团队完成或超额完成公司下达的销售指标；',
          '负责指导关键客户的谈判与合同签订，处理重大客户投诉，定期输出产品线销售报告，分析销售数据，提出改进措施；',
          '负责产品线销售团队组建，负责团队带教及绩效管理；',
          '岗位其他相关工作。'
        ],
        requirements: [
          '大专及以上学历，45周岁以内（优秀可放宽），10年以上企业客户销售经验，有5人以上销售团队管理经验；',
          '熟悉硅油产线产品的市场情况，熟悉行业内客户资源，能够带领团队实现销售突破；',
          '有团队搭建经验，有优秀市场销售业绩（千万级及以上），有突破能力。'
        ],
        locations: [
          { city: '镇江', addr: '江苏省镇江市镇江新区国际化工园区松林山路9号（希玛石油销售（镇江）有限公司）' },
          { city: '昆山', addr: '江苏省昆山市昆太路祥和国际大厦11楼1102号（希玛石油昆山办事处）' },
          { city: '上海', addr: '歆翱智慧谷上海市闵行区颛桥镇都庄路2350号（希玛石油（集团）研发和销售中心）' }
        ]
      },
      {
        name: '农化产线销售总监',
        contactName: '王经理',
        contactPhone: '18651818682',
        contactEmail: 'wangwen@ximapetro.cn',
        overview: [
          { label: '需求人数', value: '1人' },
          { label: '汇报上级', value: '集团董事长' },
          { label: '下属', value: '大客户销售经理/代表' },
          { label: '团队规模', value: '5-20人' }
        ],
        industry: '',
        duties: [
          '负责根据公司农化产线整体市场战略，结合农化产线市场特点（如竞争格局、客户需求、经济环境），制定年度、季度及月度销售计划与目标分解；',
          '负责定期分析产品线市场动态、竞争对手动向及客户痛点，识别增长机会，提出新产品研发需求；',
          '负责对产品线总销售额、毛利率、回款等核心KPI负责，确保团队完成或超额完成公司下达的销售指标；',
          '负责指导关键客户的谈判与合同签订，处理重大客户投诉，定期输出产品线销售报告，分析销售数据，提出改进措施；',
          '负责产品线销售团队组建，负责团队带教及绩效管理；',
          '岗位其他相关工作。'
        ],
        requirements: [
          '大专及以上学历，45周岁以内（优秀可放宽），10年以上企业客户销售经验，有5人以上销售团队管理经验；',
          '熟悉农化产线产品的市场情况，熟悉行业内客户资源，能够带领团队实现销售突破；',
          '有团队搭建经验，有优秀市场销售业绩（千万级及以上），有突破能力。'
        ],
        locations: [
          { city: '镇江', addr: '江苏省镇江市镇江新区国际化工园区松林山路9号（希玛石油销售（镇江）有限公司）' },
          { city: '昆山', addr: '江苏省昆山市昆太路祥和国际大厦11楼1102号（希玛石油昆山办事处）' },
          { city: '上海', addr: '歆翱智慧谷上海市闵行区颛桥镇都庄路2350号（希玛石油（集团）研发和销售中心）' }
        ]
      },
      {
        name: '润滑油销售工程师',
        contactName: '贺经理',
        contactPhone: '15151669689',
        contactEmail: 'heyaqing@ximapetro.cn',
        overview: [],
        industry: '',
        duties: [
          '负责公司油品的销售及推广；',
          '根据市场营销计划，完成部门销售目标；',
          '开拓新市场，维护老客户，增加产品销售范围。'
        ],
        requirements: [
          '大专及以上学历，会熟练开车；',
          '具备一定电销、面销的销售能力；',
          '有开发工业品相关工作经验者优先；',
          '有B端开发型销售经验优先。'
        ],
        locations: [
          { city: '昆山', addr: '江苏省昆山市昆太路《祥和国际大厦》' },
          { city: '宁波', addr: '宁波市北仑区新碶恒山路518号《致远楼》' },
          { city: '西安', addr: '西安市（居家办公）' },
          { city: '无锡', addr: '江苏省无锡市东北塘街道中元路8号《汇坚国际五金机电城》' },
          { city: '深圳', addr: '深圳市宝安区黄麻布社区簕竹角村同富裕工业园2号《宏科商务大厦》' }
        ]
      },
      {
        name: '润滑油大客户经理',
        contactName: '贺经理',
        contactPhone: '15151669689',
        contactEmail: 'heyaqing@ximapetro.cn',
        overview: [],
        duties: [
          '新客户开发并维护：寻找客户，定期拜访，建立并维护客户关系；',
          '销售目标的达成：给予提供优质的服务，帮助客户解决困扰，促成销售，并达成销售指标；',
          '回款能力：确保应收款及时收回，及时识别和解决回款过程中的问题。'
        ],
        requirements: [
          '具备从0到1开拓新市场的能力，3年以上B2B大客户销售经验，有成功开发并维护年采购额百万级客户的经验；',
          '出色的沟通协调和谈判能力，具备敏锐的市场洞察力和数据分析能力；',
          '深耕工业制造行业，对接多赛道头部客户核心决策层，具备极速业务切入与项目推进能力。'
        ],
        locations: [
          { city: '昆山', addr: '江苏省昆山市昆太路《祥和国际大厦》' },
          { city: '宁波', addr: '宁波市北仑区新碶恒山路518号《致远楼》' },
          { city: '西安', addr: '西安市（居家办公）' },
          { city: '无锡', addr: '江苏省无锡市东北塘街道中元路8号《汇坚国际五金机电城》' },
          { city: '深圳', addr: '深圳市宝安区黄麻布社区簕竹角村同富裕工业园2号《宏科商务大厦》' }
        ]
      },
      {
        name: '销售经理',
        contactName: '贺经理',
        contactPhone: '15151669689',
        contactEmail: 'heyaqing@ximapetro.cn',
        overview: [],
        industry: '',
        duties: [
          '战略规划与目标管理：完成公司销售目标，完成新客户开发；',
          '重点客户开发：亲自负责开拓和维护汽配、家电、粉末冶金、3C电子、工业设备（刀具、CNC、冲床等）等行业重点客户；',
          '客户关系深化：定期拜访关键客户，理解其工艺需求，建立稳固的战略合作关系，提升客户忠诚度；',
          '团队培训带教：搭建维护好销售团队，入职新人培训带教等。'
        ],
        requirements: [
          '熟练开车，大专及以上学历，优秀者学历可放宽；',
          '5年及以上工业制造行业（切削液/机械设备/金属管材/工业耗材等）销售经验，2年以上团队管理经验；',
          '有组建并带领5人以上团队的成功案例，自带行业客户资源者优先。'
        ],
        locations: [
          { city: '昆山', addr: '江苏省昆山市昆太路《祥和国际大厦》' },
          { city: '宁波', addr: '宁波市北仑区新碶恒山路518号《致远楼》' },
          { city: '无锡', addr: '江苏省无锡市东北塘街道中元路8号《汇坚国际五金机电城》' },
          { city: '深圳', addr: '深圳市宝安区黄麻布社区簕竹角村同富裕工业园2号《宏科商务大厦》' }
        ]
      }
    ]
  }
}
